import React from 'react';
import { motion } from 'framer-motion';
export interface SquareGridVisualProps {
  size: number;
  mode?: 'power' | 'root' | 'partial';
  targetValue?: number;
  label?: string;
}
export const SquareGridVisual: React.FC<SquareGridVisualProps> = ({
  size,
  mode = 'power',
  targetValue,
  label
}) => {
  const cellSize = 30;
  const gap = 2;
  const gridWidth = size * cellSize + (size - 1) * gap;
  const gridHeight = size * cellSize + (size - 1) * gap;
  const totalCells = size * size;
  const shadedCells = mode === 'partial' && targetValue !== undefined ? targetValue : totalCells;
  return <div className="flex flex-col items-center justify-center space-y-4" data-id="element-12635">
      <div className="relative" data-id="element-12636">
        {/* Top Label (Width) */}
        {(mode === 'power' || mode === 'root') && <div className="absolute -top-6 left-0 flex w-full justify-center text-sm font-bold text-slate-600" data-id="element-12637">
            {mode === 'root' ? '?' : size}
          </div>}

        {/* Left Label (Height) */}
        {(mode === 'power' || mode === 'root') && <div className="absolute -left-6 top-0 flex h-full items-center text-sm font-bold text-slate-600" data-id="element-12638">
            {mode === 'root' ? '?' : size}
          </div>}

        {/* Grid */}
        <div className={`grid ${mode === 'root' ? 'opacity-30 blur-[1px]' : ''}`} style={{
        gridTemplateColumns: `repeat(${size}, ${cellSize}px)`,
        gap: `${gap}px`
      }} data-id="element-12639">
          {Array.from({
          length: totalCells
        }).map((_, i) => {
          const isShaded = i < shadedCells;
          return <motion.div key={i} initial={{
            scale: 0.8,
            opacity: 0
          }} animate={{
            scale: 1,
            opacity: 1
          }} transition={{
            delay: i * 0.02,
            duration: 0.2
          }} className={`h-[30px] w-[30px] rounded-sm border ${isShaded ? 'border-blue-500 bg-blue-100' : 'border-slate-200 bg-white'}`} data-id="element-12640" />;
        })}
        </div>

        {/* Center Label (Area) */}
        {mode === 'root' && <div className="pointer-events-none absolute inset-0 flex items-center justify-center text-4xl font-black text-blue-700 drop-shadow-md" data-id="element-12641">
            {totalCells}
          </div>}
      </div>

      {label && <div className="text-center text-sm font-medium text-slate-600" data-id="element-12642">
          {label}
        </div>}
    </div>;
};